import { TranslationsContext } from '@teliaee/telia-translate';
import { Notice, Separator } from 'telia-front-react';
import * as React from 'react';
import { Segment } from '../../../stores/SegmentStore';

interface VatInfoNoticeProps {
  segment: Segment;
}

const VatInfoNotice = (props: VatInfoNoticeProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);

  if (props.segment !== 'BUSINESS') {
    return null;
  }
  return (
    <>
      <Notice size="small">
        <p>{translate('roaming.business.prices.vat-not-included')}</p>
      </Notice>
      <Separator spacing="xsmall" color="invisible" />
    </>
  );
};

export default VatInfoNotice;
